import axios from "axios";
import { axios as newAxios } from "../middleware";

const BASE_URL = process.env.REACT_APP_API_URL;
//create new information
export const createFactoringUserAPI = async (params: any) => {
  return axios.post("/factoring/", params, {
    baseURL: BASE_URL
  });
};

//join haulpay
export const updateFactoringInfoAPI = async (params: any, factoring_id: string) => {
  return axios.patch(`/factoring/${factoring_id}/`, params, {
    baseURL: BASE_URL
  });
};

export const getPaymentTermsAPI = async (factoring_id: string) => {
  return newAxios.get(`/factoring/${factoring_id}/terms/`);
};

export const getInvitedCarrierPaymentTermsAPI = async (factoring_id: string) => {
  return newAxios.get(`/factoring/${factoring_id}/payment_terms/`);
};

export const updateDefaultPaymentTermAPI = async (
  factoring_id: string,
  payment_term_id: string,
  data?: any,
  params?: any
) => {
  return axios.patch(`/factoring/${factoring_id}/payment_terms/${payment_term_id}/`, data, {
    params: params
  });
};

export const connectFactoringCompanyAPI = async (
  factoring_company_id: string,
  factoring_id: string
) => {
  return axios.post(`/factoring/company/change/`, {
    factoring_company_id,
    factoring_id
  });
};

export const getFactoringProfileAPI = async (factoring_id: string) => {
  return axios.get(`/factoring/${factoring_id}`);
};

export const updateFactoringProfileAPI = async (factoring_id: string, data: any) => {
  return axios.patch(`/factoring/${factoring_id}/`, data);
};
